import React from 'react';
import IndustriesPageComponent from '../components/IndustriesPage/IndustriesPage';

/**
 * IndustriesPage - Industries page wrapper
 */
export default function IndustriesPage() {
  return <IndustriesPageComponent />;
}
